module.exports = __webpack_public_path__ + "static/img/eleazar.fc2acab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eleazar.png
// module id = 72JP
// module chunks = 0